import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';

export const randomGenerator = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const useRandomBlogPost = () => {
  const blogposts = useStaticQuery(
    graphql`
      query {
        allMdx(filter: { fields: { posttype: { eq: "blog" } } }) {
          edges {
            node {
              frontmatter {
                title
              }
              fields {
                slug
              }
            }
          }
          totalCount
        }
      }
    `
  );

  const randomPost = React.useMemo(() => {
    let tempRandomPost = blogposts.allMdx.edges[randomGenerator(0, blogposts.allMdx.totalCount - 1)];

    if (typeof window !== 'undefined') {
      while (tempRandomPost.node.fields.slug === window.location.pathname) {
        tempRandomPost = blogposts.allMdx.edges[randomGenerator(0, blogposts.allMdx.totalCount - 1)];
        break; // Note: This break will stop the loop after one iteration, which might not be what you want.
      }
    }

    return { randomSlug: tempRandomPost.node.fields.slug, randomTitle: tempRandomPost.node.frontmatter.title };
  }, [blogposts.allMdx.edges, blogposts.allMdx.totalCount]);

  return randomPost;
};
export default useRandomBlogPost;